// Validación de dirección de email para los formularios que escriben la ficha
// de facturación (`user.email`).
//
// POR QUÉ: el campo era obligatorio y sólo se chequeaba "no vacío", así que en
// el mostrador se escribe `-` para poder guardar. Al facturar, ese `-` viaja al
// backend, llega a SES y vuelve como error de envío (2 casos en prod, agosto
// 2026). Al 2026-08-31 hay 382 fichas con un email sin `@`, casi todas `-`.
//
// ⚠️ El criterio está DUPLICADO del backend (`src/utils/email/recipient.js`) a
// propósito: son dos repos sin paquete compartido. La autoridad es el backend
// —él decide si el correo sale—; esto sólo le avisa al operador antes de
// guardar. Si allá cambia el criterio, hay que cambiarlo acá también.
const ADDRESS = /^[^\s@,;<>]+@[^\s@,;<>]+\.[A-Za-z]{2,}$/;

export function isValidEmail(value) {
  if (value == null) return false;
  return ADDRESS.test(String(value).trim());
}

// El email es OPCIONAL. Dejarlo vacío es una respuesta legítima —el cliente no
// tiene o no lo quiere dar— y el backend ya registra ese caso como SKIPPED, con
// lo cual queda rastro de por qué no le llegó la factura. Exigirlo es
// exactamente lo que generaba el hábito del `-`.
export function isAcceptableEmail(value) {
  const s = value == null ? '' : String(value).trim();
  return s === '' || isValidEmail(s);
}

export const EMAIL_INVALIDO_MSG = 'El correo no tiene un formato válido. Dejalo vacío si el cliente no tiene.';
